import { Component, OnInit, inject, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';


import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ErrorModalComponent } from 'src/app/components/ui/error-modal/error-modal.component';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DeviceService } from 'src/app/services/devices/device.service';
import { environment } from 'src/environments/environment';
import { ModalCookiesComponent } from 'src/app/components/ui/modal-cookies/modal-cookies.component';
import { user } from '@angular/fire/auth';
import { FormsModule } from '@angular/forms';
import packageJson from '../../../../../package.json';

@Component({
    selector: 'app-access',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './access.component.html',
    styleUrl: './access.component.scss'
})
export class AccessComponent {


  @ViewChild('loginAlert') loginAlert!: ElementRef;

  vista = 'social';
    username = '';
  password = '';
  showPassword = false;

  errorLogin: boolean = false;
  loginErrorText='';

  errorModal: NgbModalRef;
  modalLoad: NgbModalRef;

  showLogin: boolean = false;

  version: string = packageJson.version;

  prod = environment.production;

  loadingGoogle: boolean = false;
  loadingApple: boolean = false;


   constructor(private _auth: AuthService, private _router: Router, private _translate: TranslateService, private _modal: NgbModal, private _devices: DeviceService, private cdr: ChangeDetectorRef) {
   }

  async ngOnInit(): Promise<void> {
    this.errorLogin = false;


    const cookiesConsent = localStorage.getItem('cookies');
    if (cookiesConsent !== `true ${this.version}`) {
      try {
        await this._modal.open(ModalCookiesComponent, {
          centered: true,
          backdrop: 'static',
          keyboard: false
        }).result;
      } catch {
        // dismissed: no-op
      }
    }

    // Para detectar el idioma del navegador y aplicarlo a la app
    // console.log(  'Idioma del navegador  '+ this._translate.getBrowserLang() );
    this._translate.use( this._translate.getBrowserLang() );




    this._auth.user.subscribe(async data => {
      if(data && data.emailVerified){
         // Forzar token fresco
         await data.getIdToken(true);
        //  this.modalLoad=this._modal.open(LoadingPopupComponent, {centered: true});
         this.userAuthenticated();
       }else{
         this.showLogin=true;
       }
     });

  }




  navigateToForgot(): void {
    console.log('Navegando a forgot...');
    this._router.navigate(['/login/forgot']);
  }

  navigateToRegister(): void {
    console.log('Navegando a register...');
    this._router.navigate(['/login/register']);
  }


    login(){
    // this.modalLoad=this._modal.open(LoadingPopupComponent, {centered: true});
    this.loginErrorText=this._translate.instant('invalidCredentials');
    this.showLogin=false;
    this.showPassword = false;

    this._auth.login(this.username, this.password)
      .then(data=>{
        console.log('data login', data);
        data.user?.getIdToken(true).then(token=>{
          // this.modalLoad.close();
          this.userAuthenticated();
        });
      }, err=>{
        console.error(err);
        this.errorLogin = true;
        this.mostrarError();
        // this.modalLoad.close();
        // this.errorModal=this._modal.open(ErrorModalComponent);
        this.errorModal.componentInstance.description=this._translate.instant("invalidCredentials");
        this.showLogin=true;
      })
  }

    userAuthenticated() {
    let role = sessionStorage.getItem('role');
    let redirectUrl = localStorage.getItem('redirectUrl'); // Obtiene la URL guardada
    this._devices.getDevices().subscribe(
      (devices) => {
        // this.modalLoad.close();

        if (redirectUrl) {
          // Si hay una URL guardada, redirige a ella
          this._router.navigateByUrl(redirectUrl);
          localStorage.removeItem('redirectUrl'); // Limpia la URL después de redirigir
        } else if (role == 'admin') {
          // Redirige al panel de administración si es administrador
          this._router.navigate(['/dashboard/administration/search']);
        } else if (devices.length == 1) {
          // Si solo tiene un dispositivo, redirige directamente a él
          this._router.navigate(['/dashboard/device', devices[0].serial]);
        } else {
          // Redirige al dashboard por defecto
          this._router.navigate(['/dashboard']);
        }
      },
      (error) => {
        console.log(error);
        this.modalLoad.close();
      }
    );
  }

  async loginWithGoogle() {
    if (this.loadingGoogle) return;
    this.loadingGoogle = true;
    this.loginErrorText = this._translate.instant('invalidCredentials');
    this.showLogin = false;

    try {
      const cred = await this._auth.loginWithGoogle();
      await cred.user?.getIdToken(true);
      this.userAuthenticated();
    } catch (err) {
      console.error('Error al iniciar sesión con Google:', err);
      this.showLogin = true;
      this.mostrarError();
    } finally {
      this.loadingGoogle = false;
      this.modalLoad?.close();
    }
  }

  async loginWithApple() {
    if (this.loadingApple) return;
    this.loadingApple = true;
    this.loginErrorText = this._translate.instant('invalidCredentials');
    this.showLogin = false;

    try {
      const cred = await this._auth.loginWithApple();
      await cred.user?.getIdToken(true);
      this.userAuthenticated();
    } catch (err) {
      console.error('Error al iniciar sesión con Apple:', err);
      this.showLogin = true;
      this.mostrarError();
    } finally {
      this.loadingApple = false;
      this.modalLoad?.close();
    }
  }


mostrarError() {
    // 1) Oculta por si estaba visible (fuerza desmontaje del *ngIf)
    this.errorLogin = false;
    // Si usas ChangeDetectionStrategy.OnPush, fuerza un ciclo:
    this.cdr.detectChanges();

    // 2) Muestra de nuevo en el siguiente tick (fuerza re-montaje limpio)
    setTimeout(() => {
      this.errorLogin = true;
      this.cdr.detectChanges();

      // 3) Añade animación de entrada
      setTimeout(() => {
        if (this.loginAlert) {
          const el = this.loginAlert.nativeElement;
          el.classList.remove('hide');
          el.classList.add('show');
        }
      });

      // 4) Auto-ocultar a los 3s con animación de salida
      setTimeout(() => {
        if (this.loginAlert) {
          const el = this.loginAlert.nativeElement;
          el.classList.remove('show');
          el.classList.add('hide');

          // 5) Tras la transición, desmonta del DOM
          setTimeout(() => {
            this.errorLogin = false;
            this.cdr.detectChanges();
          }, 400); // mismo tiempo que el transition del CSS
        }
      }, 4000);
    });
  }



}
